interface TestimonialProps {
  translate: (key: string) => string;
  variant?: "sidebar" | "mobile";
}

const Star = ({ size = 11, color = "#00B67A" }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} aria-hidden>
    <path d="M12 2l2.9 6.9L22 10l-5.5 4.8L18 22l-6-3.6L6 22l1.5-7.2L2 10l7.1-1.1z" />
  </svg>
);

const Testimonial = ({ translate, variant = "sidebar" }: TestimonialProps) => (
  <div className={`paymentV3Testimonial paymentV3Testimonial--${variant}`}>
    <div className="paymentV3Testimonial__quoteMark">“</div>
    <div className="paymentV3Testimonial__body">
      <div className="paymentV3Testimonial__avatar">
        {translate("paymentV3.summary.testimonial.initials")}
      </div>
      <div className="paymentV3Testimonial__text">
        <p className="paymentV3Testimonial__quote">
          {translate("paymentV3.summary.testimonial.quote")}
        </p>
        <div className="paymentV3Testimonial__meta">
          <span className="paymentV3Testimonial__stars">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} size={11} color="#00B67A" />
            ))}
          </span>
          <span className="paymentV3Testimonial__attribution">
            <strong>{translate("paymentV3.summary.testimonial.author")}</strong>
            {" · "}
            {translate("paymentV3.summary.testimonial.location")}
          </span>
        </div>
      </div>
    </div>
    <div className="paymentV3Testimonial__footer">
      <span>
        <span className="paymentV3Testimonial__dot" />
        {translate("paymentV3.summary.testimonial.verified")}
      </span>
      <a
        href={translate("paymentV3.summary.testimonial.moreLink")}
        className="paymentV3Testimonial__more"
        target="_blank"
        rel="noreferrer"
      >
        {translate("paymentV3.summary.testimonial.more")}
      </a>
    </div>
  </div>
);

export default Testimonial;
